// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__pk30l","requiredAsterisk":"Info_requiredAsterisk__8-h1N"};